if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const productVariantId = this.variantIdInput.value;

        const wrapCheckbox =
          this.form.querySelector('[data-gift-wrap]');

        if (wrapCheckbox && wrapCheckbox.checked) {
          const quantity = Number(formData.get('quantity') || 1);
          const sellingPlan = formData.get('selling_plan');
          const properties = [];

          for (const [key, value] of formData.entries()) {
            if (
              key.startsWith('properties[') &&
              key.endsWith(']')
            ) {
              properties.push([key.slice(11, -1), value]);
            }
          }

          formData.delete('id');
          formData.delete('quantity');
          formData.delete('selling_plan');

          for (const [name] of properties) {
            formData.delete(`properties[${name}]`);
          }

          formData.append('items[0][id]', productVariantId);
          formData.append('items[0][quantity]', quantity);

          if (sellingPlan) {
            formData.append(
              'items[0][selling_plan]',
              sellingPlan
            );
          }

          for (const [name, value] of properties) {
            formData.append(
              `items[0][properties][${name}]`,
              value
            );
          }

          formData.append(
            'items[0][properties][Cadeauverpakking]',
            'Ja'
          );

          formData.append(
            'items[1][id]',
            '63909746934090'
          );

          formData.append('items[1][quantity]', quantity);

          formData.append(
            'items[1][properties][Voor artikelvariant]',
            productVariantId
          );
        }

        // Zoek het winkelmandje opnieuw als het later geladen is.
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',')
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(routes.cart_add_url, config)
          .then((response) => {
            return response.json();
          })
          .then(async (response) => {
            if (response.status) {
              this.error = true;

              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (soldOutMessage) {
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              } else {
                this.submitButton.removeAttribute(
                  'aria-disabled'
                );
              }

              return;
            }

            // Behoud artikelgegevens en winkelmandsecties
            // wanneer meerdere artikelen tegelijk zijn toegevoegd.
            if (response.items && response.items.length) {
              response = {
                ...response.items[0],
                ...response,
              };
            }

            // Werk de kerstposter bij voordat het mandje
            // opnieuw wordt weergegeven.
            if (
              typeof window.sjaakieSyncPoster !== 'function'
            ) {
              throw new Error(
                'De kerstposterfunctie is niet geladen. Vernieuw de pagina en controleer je winkelwagen.'
              );
            }

            const posterSectionRequest = this.cart
              ? {
                  sections: this.cart
                    .getSectionsToRender()
                    .map((section) => section.id),
                  sections_url: window.location.pathname,
                }
              : {};

            const posterCart =
              await window.sjaakieSyncPoster(
                posterSectionRequest
              );

            if (posterCart && this.cart) {
              response.sections = posterCart.sections;
            }

            if (!this.cart) {
              window.location.href = window.routes.cart_url;
              return;
            }

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            const updateResult = publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source: 'product-form',
                productVariantId: productVariantId,
                cartData: response,
              }
            );

            Promise.resolve(updateResult)
              .then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              })
              .catch(console.error);

            const renderCart = () => {
              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(response);
                }
              );
            };

            const quickAddModal =
              this.closest('quick-add-modal');

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(renderCart);
                },
                { once: true }
              );

              quickAddModal.hide(true);
            } else {
              renderCart();
            }
          })
          .catch((error) => {
            console.error(error);

            this.handleErrorMessage(
              'Het toevoegen of bijwerken van het winkelmandje is niet afgerond. Controleer je winkelwagen voordat je opnieuw toevoegt.'
            );
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (
              this.cart &&
              this.cart.classList.contains('is-empty')
            ) {
              this.cart.classList.remove('is-empty');
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add('hidden');
            }

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}

